var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scripter skew-11-neg"
  }, [_c('div', {
    staticClass: "text-section"
  }, [_c('div', {
    staticClass: "text-section-title"
  }, [_vm._v("Scripter")]), _vm._v(" "), _c('div', {
    staticClass: "text-section-content"
  }, [_vm._v("\n      During my third year of studying for my B.Sc. at "), _c('a', {
    attrs: {
      "href": "https://www.dcu.ie/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("DCU")]), _vm._v(", I worked with a friend of mine to develop our "), _c('strong', [_vm._v("first Android application")]), _vm._v(" named "), _c('a', {
    attrs: {
      "href": "https://github.com/grabartley/scripter",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Scripter")]), _vm._v(".\n      It gives you "), _c('strong', [_vm._v("greater control")]), _vm._v(" over your device by allowing you to explain "), _c('strong', [_vm._v("simple logic")]), _vm._v(" in JavaScript\n      which can be used to "), _c('strong', [_vm._v("run tasks automatically")]), _vm._v(" in the background.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('img', {
    attrs: {
      "src": require("../assets/scripter-logo.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v("\n      For example, this short script could be used with Scripter to turn your device on silent mode when\n      within 15 meters of the Googleplex building in California...\n      "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "id": "example-script",
      "src": require("../assets/scripter-example-script.png")
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      This is just one example of the many possible uses of Scripter! The "), _c('a', {
    attrs: {
      "href": "https://github.com/grabartley/scripter",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("source code for Scripter")]), _vm._v(" can now be found on my GitHub profile.\n    ")], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae7ab1da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scripter.vue
// module id = i4hD
// module chunks = 0